var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.canIncrease() ||
    _vm.compoQty != 0 ||
    _vm.ShopService.shop.canOrder == 0
    ? _c(
        "li",
        {
          staticClass: "menuCompoList gridChoice p-5 col-xs-12 col-sm-6",
          class: { optionSelected: _vm.compoQty != 0 },
          on: {
            click: function ($event) {
              return _vm.toggleCompo()
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "content flex-between-center h-100 p-15 no-overflow pos-relative",
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "details flex-between-start flex-column h-100 text-left",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "title display-5 color-grey6 text-bold mb-5",
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(
                            _vm.truncate(
                              _vm.product.dn,
                              _vm.DISPLAY_LENGTH.mosaic.product.title
                            )
                          ) +
                          "\n\t\t\t"
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    { staticClass: "description display-6 color-grey6" },
                    [_vm._v(_vm._s(_vm.stripHtml(_vm.product.dd)))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "priceDetails display-6 flex-start-center" },
                    [
                      _vm.price
                        ? _c("div", { staticClass: "price color-1 mr-20" }, [
                            _vm._v(
                              "+" + _vm._s(_vm.ShopService.prix(_vm.price))
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.product.Promo ? _c("promo-list-view") : _vm._e(),
                      _vm._v(" "),
                      (_vm.product.allergens && _vm.product.allergens.length) ||
                      (_vm.product.consumables &&
                        _vm.product.consumables.length)
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "flex-start-center color-grey1 hover-ko ml-10",
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  _vm.popInfoProdOpen = !_vm.popInfoProdOpen
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "fie-icon_warning-eat fsize-16 mr-5",
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "fsize-12" }, [
                                _vm._v(_vm._s(_vm.infoAllergens(_vm.product))),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "pic ml-10 pos-relative" }, [
                _vm.menuCompo.product.imt
                  ? _c("img", {
                      staticClass: "img-fit img-fluid",
                      attrs: {
                        src: _vm.UrlService.imagePath(
                          _vm.menuCompo.product.ShopId,
                          _vm.menuCompo.product.imt
                        ),
                        alt: _vm.menuCompo.product.dn,
                      },
                      on: {
                        error: function ($event) {
                          $event.target.src = "dist/assets/no-img.png"
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.category.ChoicesNumber !== 1 && _vm.compoQty > 0
                  ? _c(
                      "div",
                      { staticClass: "addCart plusMinus flex-center-center" },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "minus",
                            style: {
                              background: _vm.canDecrease() ? "" : "#b8b6b7",
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.decreaseCompo()
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "icon-eatselfapp_minus",
                              style: { color: _vm.canDecrease() ? "" : "#fff" },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.compoQty))]),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "more cursor-pointer",
                            style: {
                              background: _vm.canIncrease() ? "" : "#b8b6b7",
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.increaseCompo()
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "icon-eatselfapp_more",
                              style: { color: _vm.canIncrease() ? "" : "#fff" },
                            }),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.category.ChoicesNumber == 1 && _vm.compoQty > 0
                  ? _c(
                      "div",
                      { staticClass: "addCart plusMinus flex-center-center" },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "minus cursor-pointer",
                            style: {
                              background: _vm.canDecrease() ? "" : "#b8b6b7",
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.decreaseCompo()
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "icon-eatselfapp_minus",
                              style: { color: _vm.canDecrease() ? "" : "#fff" },
                            }),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "ease-2 left-0 pos-absolute wh-100 bg-black-opacity-08 top-0 zindex-1 cursor-default",
                  class: {
                    "top-0 opacity-1": _vm.popInfoProdOpen,
                    "top-100 opacity-0": !_vm.popInfoProdOpen,
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex-center-center flex-column wh-100" },
                    [
                      _c(
                        "div",
                        { staticClass: "color-white text-bold fsize-12 mb-10" },
                        [_vm._v(_vm._s(_vm.infoAllergens(_vm.product)))]
                      ),
                      _vm._v(" "),
                      _c("product-tags", { attrs: { product: _vm.product } }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "cursor-pointer hover-ko flex-center-center size-wh-30 bg-grey1 color-white m-10 mt-15 radius-50 pos-absolute top-0 right-0 zindex-1",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          _vm.popInfoProdOpen = false
                        },
                      },
                    },
                    [_c("i", { staticClass: "fie-icon_close fsize-10" })]
                  ),
                ]
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }